module.exports = __webpack_public_path__ + "dcd3851ef48964dd658ce50d5e00977f.png";